import Heading, {HEADING_TYPES} from '@frontend/ui-kit/Components/Heading';
import Button, {BUTTON_TYPES} from '@frontend/ui-kit/Components/Button';
import {Props} from './types';
import styles from './index.module.scss';

const TermsAndConditionsPopup = ({document, onAccept, onClose}: Props) => {
    return (
        <div data-testid='terms-and-conditions-popup' className={styles['terms-and-conditions-popup']}>
            <Heading className={styles['terms-and-conditions-popup__title']} type={HEADING_TYPES['1']}>Terms and Conditions</Heading>

            <div className={styles['terms-and-conditions-popup__content']} dangerouslySetInnerHTML={{__html: document.content || ''}}/>

            <div className={styles['terms-and-conditions-popup__action-bar']}>
                <Button className={styles['terms-and-conditions-popup__button']}
                    data-testid='terms-close-button'
                    type={BUTTON_TYPES.secondary}
                    onClick={onClose}>
                    Cancel
                </Button>
                <Button className={styles['terms-and-conditions-popup__button']}
                    data-testid='terms-accept-button'
                    type={BUTTON_TYPES.primary}
                    onClick={onAccept}>
                    Accept
                </Button>
            </div>
        </div>
    );
};

export {TermsAndConditionsPopup as TestableTermsAndConditionsPopup};
export default TermsAndConditionsPopup;
